import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

@Component({
  selector: 'chip',
  styleUrls: ['./chip.component.scss'],
  templateUrl: './chip.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChipComponent {
  @Input() text: string;
  @Input() subtext: string;
  @Input() description: string;
  @Input() invalid: boolean = false;
  @Input() disabled: boolean = false;
  @Input() focused: boolean = false;
  @Input() removable: boolean = true;
  @Input() squareChip: boolean = false;
  @Input() useTooltip: boolean = true;
  @Output() remove = new EventEmitter();

  getTooltip() {
    if (!this.useTooltip) return undefined;
    return this.description != null ? this.description : this.text;
  }
}
